module.exports = __webpack_public_path__ + "assets/img/icon_search.fa06f7b7.svg";